import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-form-card-header',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './form-card-header.component.html',
  styleUrl: './form-card-header.component.scss'
})
export class FormCardHeaderComponent {
  @Input() title?: string;
  @Input() description?: string;
  @Input() icon?: string;       // Pass icon class like "bi bi-house-door"
  @Input() logoUrl?: string;    // Pass image path if using an actual asset logo
  @Input() showHeading = false;
}
